export enum LogLevel {
Trace = "Trace",
Debug = "Debug",
Information = "Information",
Warning = "Warning",
Error = "Error",
Critical = "Critical",
None = "None",
}
